import React from 'react';
import { Badge, Button, Form } from 'react-bootstrap';
import { Search, SlidersHorizontal, X } from 'lucide-react';
import { KeyStatusFilter } from './keyRegisterView';
import { keyTableTitle } from './keyRegisterLabels';

/** A set filter shown under the toolbar, removable on its own. */
export interface KeyFilterChip {
    id: string;
    label: string;
    onRemove: () => void;
}

interface KeyRegisterToolbarProps {
    /** The active summary-card filter; names the table. */
    statusFilter: KeyStatusFilter | null;
    query: string;
    onQueryChange: (query: string) => void;
    /** Set filters in the filter modal: the button's badge. */
    filterCount: number;
    onOpenFilters: () => void;
    chips: KeyFilterChip[];
}

/** Header of the table card ("Alla nycklar", or the active card's title): search, the filter button and the set filters. */
const KeyRegisterToolbar: React.FC<KeyRegisterToolbarProps> = ({
    statusFilter, query, onQueryChange, filterCount, onOpenFilters, chips,
}) => (
    <div className="key-toolbar-wrap">
        <div className="key-toolbar">
            <h2 className="key-toolbar-title">{keyTableTitle(statusFilter)}</h2>
            <div className="key-toolbar-controls">
                <div className="key-search">
                    <Search size={16} className="key-search-icon" aria-hidden="true" />
                    <Form.Control
                        type="search"
                        className="key-search-input"
                        placeholder="Sök nycklar…"
                        aria-label="Sök nycklar"
                        value={query}
                        onChange={e => onQueryChange(e.target.value)}
                    />
                </div>
                <Button variant="light" className="key-toolbar-filter" onClick={onOpenFilters}>
                    <SlidersHorizontal size={18} aria-hidden="true" />
                    <span>Filter</span>
                    {filterCount > 0 && <Badge pill bg="primary" aria-label={`${filterCount} aktiva`}>{filterCount}</Badge>}
                </Button>
            </div>
        </div>
        {chips.length > 0 && (
            <div className="key-filter-chips">
                {chips.map(chip => (
                    <span key={chip.id} className="key-filter-chip">
                        {chip.label}
                        <button type="button" className="key-filter-chip-remove" aria-label={`Ta bort filter: ${chip.label}`} onClick={chip.onRemove}>
                            <X size={14} aria-hidden="true" />
                        </button>
                    </span>
                ))}
            </div>
        )}
    </div>
);

export default KeyRegisterToolbar;
